// API helpers shared by the DB Tools sub-components. Auth lives in the
// httpOnly admin_access_token cookie, sent automatically
// (axios.defaults.withCredentials = true, set in App.js).
import axios from 'axios';

export const adminGet = (url, opts = {}) => {
  return axios.get(url, opts);
};

export const adminPost = (url, body, opts = {}) => {
  return axios.post(url, body, opts);
};

export const adminDelete = (url) => {
  return axios.delete(url);
};

// Re-export the shared Brunei timestamp formatter — DB Tools audit table
// renders every entry in Asia/Brunei regardless of viewer's browser tz.
export { bruneiFormatTs as formatTs } from '../../../lib/brunei';

// Reads an axios error body (Blob | string | object) into a friendly message.
export const errMsg = async (e, fallback = 'Request failed') => {
  const detail = e.response?.data;
  if (detail instanceof Blob) {
    try { return JSON.parse(await detail.text()).detail || fallback; }
    catch { return fallback; }
  }
  if (typeof detail === 'string') return detail;
  if (detail?.detail) return detail.detail;
  return fallback;
};
